import $ from 'jquery';

/**
 * Handle set shipping address as default events
 *
 * @type {JQuery.EventHandler<HTMLElement>}
 */
const shippingAddressDefault = async function(e) {

	e.preventDefault();

	const triggerElement = this;
	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const address_id = String(triggerElement.dataset.addressId || '');
	const extraOptions = elemData;

	if ($trigger.find(':checkbox').prop('checked') === true) {
		e.stopPropagation();
		e.stopImmediatePropagation();
		return;
	}

	// Addresses api
	const { addresses } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = addresses.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await addresses['shipping_address_default']({ id: address_id });
		// Execute all defined success handlers for the current action
		addresses.runSuccessHandlers('shipping_address_default', res, triggerElement, overrideActions.success);
	}
	catch (error) {
		// Default error handler
		addresses.runErrorHandlers('shipping_address_default', error, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
};

/**
 * Handle set billing address as default events
 *
 * @type {JQuery.EventHandler<HTMLElement>}
 */
const billingAddressDefault = async function(e) {

	e.preventDefault();

	const triggerElement = this;
	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const address_id = String(triggerElement.dataset.addressId || '');
	const extraOptions = elemData;

	if ($trigger.find(':checkbox').prop('checked') === true) {
		e.stopPropagation();
		e.stopImmediatePropagation();
		return;
	}

	// Addresses api
	const { addresses } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = addresses.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await addresses['billing_address_default']({ id: address_id });
		// Execute all defined success handlers for the current action
		addresses.runSuccessHandlers('billing_address_default', res, triggerElement, overrideActions.success);
	}
	catch (error) {
		// Default error handler
		addresses.runErrorHandlers('billing_address_default', error, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
};

/**
 * Handle delete address events
 *
 * @type {JQuery.EventHandler<HTMLElement>}
 */
const addressDelete = async function(e) {

	e.preventDefault();

	const triggerElement = this;
	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const address_id = String(triggerElement.dataset.addressId || '');
	const extraOptions = elemData;

	// Addresses api
	const { addresses } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = addresses.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await addresses['address_delete']({ id: address_id });
		// Execute all defined success handlers for the current action
		addresses.runSuccessHandlers('address_delete', res, triggerElement, overrideActions.success);
	}
	catch (error) {
		// Default error handler
		addresses.runErrorHandlers('address_delete', error, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
};

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Handle click event for shipping address as default
	$B.on('click.shippingAddressDefault', 'a[data-shipping-address-default]', shippingAddressDefault);

	// Handle click event for billing address as default
	$B.on('click.billingAddressDefault', 'a[data-billing-address-default]', billingAddressDefault);

	// Handle click event for address delete
	$B.on('click.addressDelete', 'a[data-address-delete]', addressDelete);
});
